import { Component } from '@angular/core';
import { DialogContent } from '@shared/components/dialog/dialog.component';

export interface ChoosePipelineData {
    availablePipelines: any[];
    pipeline: any;
}

@Component({
    selector: 'sfx-choose-pipeline-content',
    template: `
        <p translate>
            Choose a pipeline for the opportunity.
        </p>
        <span>
            <mat-form-field class="select-option">
                <mat-label translate>Options</mat-label>
                <mat-select [(ngModel)]="pipeline">
                    <mat-option *ngFor="let option of availablePipelines" [value]="option">
                        {{ option.name }}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </span>
    `,
    styles: ['.mat-form-field { width: 100% }; .select-option { min-width: 300px }']
})
export class ChoosePipelineComponent implements DialogContent<ChoosePipelineData> {

    public availablePipelines: any[] = [];
    public pipeline: any;

    public valid: true;

    setInitialState(context: ChoosePipelineData) {

        this.availablePipelines = context.availablePipelines;
        this.pipeline = context.pipeline;
    }

    getCurrentState(): ChoosePipelineData {

        return {
            availablePipelines: this.availablePipelines,
            pipeline: this.pipeline
        };
    }
}
